import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllEmployee,
  selectAllEmployee,
} from "../../redux/users/usersSlice";
import { useNavigate, useParams } from "react-router-dom";
import { Icon } from "@iconify-icon/react/dist/iconify.mjs";
import UserEditModal from "../../components/employee/UserEditModal";
import { deleteUser } from "../../utils/api/users";
import { toast } from "react-toastify";
import PopConfirm from "../../components/company/PopConfirm";
import { selectAdmin } from "../../redux/admin/adminSlice";

function AllEmployee() {
  const dispatch = useDispatch();
  const employees = useSelector(selectAllEmployee);
  const [openModal, setOpenModal] = useState(false);
  const [user, setUser] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [confirmPopup, setConfirmPopup] = useState(false);
  const navigate = useNavigate();
  const admin = useSelector(selectAdmin);


  const { companyId } = useParams();

  useEffect(() => {
    dispatch(getAllEmployee(companyId));
  }, [dispatch, refresh]);

  const handleDeleteUser = async (user) => {
    try {
      await deleteUser(user.id);
      toast.success("User Deleted");
      setRefresh(!refresh);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="p-8 ">
      <div className="flex  gap-2">
        <Icon
          onClick={() => navigate("/dashboard/companies")}
          className="text-4xl pr-2 cursor-pointer"
          icon="ion:arrow-back-circle-outline"
        />
        <h1 className="mb-4 text-2xl font-semibold">All Employees</h1>
      </div>
      {employees?.length > 0 ? (
        <>
          <table className="min-w-full border border-collapse border-gray-300 shadow-lg table-auto">
            <thead>
              <tr className="bg-gray-200">
                <th className="px-4 py-2 border border-gray-300">Name</th>
                <th className="px-4 py-2 border border-gray-300">Email</th>
                {admin.role === "administrator" &&
                <th className="px-4 py-2 border border-gray-300">Actions</th>
                }
              </tr>
            </thead>
            <tbody>
              {employees.map((employee, index) => (
                <tr
                  key={employee.id}
                  className={index % 2 === 0 ? "bg-gray-100" : "bg-white"}
                >
                  <td className="px-4 py-2 border border-gray-300">
                    {employee.name}
                  </td>
                  <td className="px-4 py-2 border border-gray-300">
                    {employee.email}
                  </td>
                  {admin.role === "administrator" &&
                  <td className="px-4 py-2 border border-gray-300 text-center">
                    <div className="flex justify-center items-center gap-2">
                      <Icon
                        // onClick={() => handleEditClick(company)}
                        onClick={() => {
                          setUser(employee);
                          setOpenModal(true);
                        }}
                        className="text-lg text-blue-700 cursor-pointer"
                        icon="fluent:clipboard-text-edit-48-regular"
                      />
                      <Icon
                        onClick={() => {
                          // handleDeleteUser(employee);
                          setUser(employee);
                          setConfirmPopup(true);
                        }}
                        className="text-lg text-gray-700 cursor-pointer"
                        icon="mingcute:delete-2-fill"
                      />
                    </div>
                  </td>
}
                </tr>
              ))}
            </tbody>
          </table>
          {openModal && (
            <UserEditModal
              refresh={refresh}
              closeModal={setOpenModal}
              user={user}
              setRefresh={setRefresh}
            />
          )}
          {confirmPopup && (
            <PopConfirm
              closePopup={setConfirmPopup}
              confirm={handleDeleteUser}
              item={user}
            />
          )}
        </>
      ) : (
        <p>No employees found</p>
      )}
    </div>
  );
}

export default AllEmployee;
